export default "__VITE_ASSET__Dh$WRVBn__"